import {useEffect, useState} from 'react';

// Set only by the isolated build browser, never included in generated HTML.
export const isPrerenderCapture = () =>
    typeof window !== 'undefined' && window.__VIEUNITE_PRERENDER_CAPTURE__ === true;

// Keep the captured first slide/poster until the live page is actually visible.
export function usePrerenderPresentation() {
    const [skipEntrance] = useState(() => isPrerenderCapture() ||
        Boolean(document.getElementById('prerender-shell')));
    const [ready, setReady] = useState(() => !skipEntrance);
    useEffect(() => {
        if (isPrerenderCapture()) return;
        const onReady = () => setReady(true);
        if (document.documentElement.dataset.vieuniteApp === 'ready') onReady();
        window.addEventListener('vieunite:ready', onReady);
        return () => window.removeEventListener('vieunite:ready', onReady);
    }, []);
    return {ready, skipEntrance};
}
